module.exports = __webpack_public_path__ + "static/media/tp4.bdd9ae85.jpg";